import React from 'react';

import { ModelTopBar } from '~/src/dash/components/model-topbar';
import { Panel, PanelBreak, Panels, Row, Rows, spacing, Span, Text } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';
import { routeName } from '~/src/dash/utils/routes';
import { useBaseStore } from '~/src/dash/views/base/contexts';
import { sandboxConfig } from '~/src/dash/views/sandbox/config';
import { SandboxContext } from '~/src/dash/views/sandbox/contexts';
import { BrowserSizeTracker } from '~/src/dash/views/sandbox/Sandbox/BrowserSizeTracker';
import { ContextsDemo } from '~/src/dash/views/sandbox/Sandbox/ContextsDemo';
import { GeneralLayoutProps } from '~/src/dash/views/sandbox/Sandbox/GeneralLayoutProps';
import { PanelSizeTracker } from '~/src/dash/views/sandbox/Sandbox/PanelSizeTracker';
import { ResponsiveDemo } from '~/src/dash/views/sandbox/Sandbox/ResponsiveDemo';
import { TextAndButtonsDemo } from '~/src/dash/views/sandbox/Sandbox/TextAndButtonsDemo';

const cfg = sandboxConfig;

export const Sandbox = () => {
  const { classes, location, session, user } = useBaseStore();
  const { pathname } = location;

  return (
    <SandboxContext.Provider value={{ cfg }}>
      <Panels maxWidth vertical relative minWidthMain>
        <Panel
          largeHorizontalPadding
          verticalPadding
          style={{ borderBottom: `1px solid ${publicaColors.lightGray}` }}
        >
          <ModelTopBar
            title={routeName(pathname)}
            session={session}
            user={user}
            publisher={session.publisher}
            classes={classes}
            currentPath={pathname}
            disableTitlePaddingLeft
          />
        </Panel>
        <Panel scroll>
          <Panels maxWidth vertical relative minWidthMain largePadding>
            <Panel>
              <Rows>
                <Row noVerticalPadding>
                  <Text header>Welcome to the Sandbox</Text>
                </Row>
                <Row noVerticalPadding>
                  <Text small muted>
                    Do not merge any changes here to master. This is strictly for local testing.{' '}
                    <Span italic>Consider creating a local branch for Sandbox use</Span>.
                  </Text>
                </Row>
                <Row>
                  <Text bold highlighted>
                    {`Please reference Brands Dashboard if you'd like to see an example of Panelization and the most common props for <Panels> & <Panel>.`}
                  </Text>
                </Row>
              </Rows>
            </Panel>
            <Panel marginBottom={spacing.large}>
              <BrowserSizeTracker />
            </Panel>
            <Panel muted enableSize marginBottom={spacing.large}>
              <PanelSizeTracker />
            </Panel>
            <Panel highlighted basePadding marginBottom={spacing.large}>
              <ResponsiveDemo />
            </Panel>
            <Panel basePadding marginBottom={spacing.large}>
              <ContextsDemo />
            </Panel>
            <Panel enableSize marginBottom={spacing.large}>
              <TextAndButtonsDemo />
            </Panel>
            <Panel muted marginBottom={spacing.large}>
              <GeneralLayoutProps />
            </Panel>
            <PanelBreak />
          </Panels>
        </Panel>
      </Panels>
    </SandboxContext.Provider>
  );
};
